// EcommerceBanner.tsx
// Bootstrap / SCSS version (no Tailwind). Desktop: price pinned bottom-right.

interface BannerData {
  show: boolean;
  campaign: string; // e.g. "Vara topește prețurile"
  normalPrice: string; // e.g. "€2400"
  discountPrice: string; // e.g. "€1200"
  discount: string; // optional
  text: string; // optional
  urgency: string; // optional
}

interface Props {
  data: BannerData;
}

export default function EcommerceBanner({ data }: Props) {
  if (!data.show) return null;

  return (
    <div className="container my-4">
      <div className="ccoffer-wrap">
        <div className="ccoffer-card">
          {/* Badge, title, subline, CTA (left block) */}
          <div className="ccoffer-badge">
            ÎNCHEIEM VARA ÎN 36 AUGUST! <span className="dot" />
          </div>

          <h2 className="ccoffer-title">
            Magazinul tău online MAI BUN decât shopify, woo-commerce, chiar și
            Magento. ULTIMELE ZILE la -50%!
          </h2>

          <p className="ccoffer-sub">
            Magazinul tău online de TOP cu 100% SEO, viteză nebună, opțiuni
            peste opțiuni și ZERO taxe lunare! Ofertă limitată pentru pachetul{" "}
            <span className="text-white">CCShop BASIC</span>. Preț special
            valabil în campania „{data.campaign}”, până în 5 septembrie 2025.
          </p>

          {/* Prices: inline under text on mobile/tablet; ABSOLUTE to the right on desktop */}
          <div className="ccoffer-price-row">
            <span className="old">{data.normalPrice}</span>
            <span className="new">{data.discountPrice}</span>
          </div>

          <a
            href="https://wa.me/40745371620?text=Vreau%20CCshop%20BASIC%20la%20preț%20redus%20-%20Vara%20topește%20prețurile"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-light ccoffer-cta mt-2"
          >
            Vreau magazinul acum!
          </a>
        </div>
      </div>

      <style>{`
        /* === Palette === */
        :root{
          --bg1:#050505;
          --bg2:#0c1104;
          --teal:#a9f2d0;
          --peach:#eeb17f;
          --muted:#9aa19f;
        }

        /* === Card with gradient hairline === */
        .ccoffer-wrap{
          border-radius: 22px;
          padding: 1px;
          background: linear-gradient(135deg, rgba(36,196,157,0.35), rgba(238,177,127,0.35));
        }
        .ccoffer-card{
          position: relative;
          border-radius: 20px;
          padding: 28px 24px;              /* mobile/tablet padding */
          background: linear-gradient(135deg, var(--bg1) 0%, var(--bg2) 100%);
          overflow: hidden;
        }
        @media (min-width:768px){
          .ccoffer-card{ padding: 32px 32px; }
        }
        /* Reserve space on desktop for the right-side price block */
        @media (min-width:1200px){
          .ccoffer-card{ padding: 40px 320px 40px 40px; } /* extra right padding so text never collides */
        }

        /* soft glow */
        .ccoffer-card::before{
          content:""; position:absolute; inset:-80px; pointer-events:none; filter:blur(32px);
          background:
            radial-gradient(60% 60% at 15% 10%, rgba(36,196,157,.22) 0%, rgba(36,196,157,0) 60%),
            radial-gradient(55% 55% at 85% 90%, rgba(238,177,127,.16) 0%, rgba(238,177,127,0) 60%);
          opacity:.25;
        }

        /* === Badge === */
        .ccoffer-badge{
          display:inline-flex; align-items:center; gap:8px;
          border:1px solid var(--teal); color:var(--teal);
          padding:6px 12px; border-radius:999px;
          font-size:12px; letter-spacing:.04em;
        }
        .ccoffer-badge .dot{
          display:inline-block; width:6px; height:6px; border-radius:50%; background:var(--teal);
        }

        /* === Title (Space Grotesk only) === */
        .ccoffer-title{
          margin:14px 0 8px;
          color:#fff;
          font-weight:700;
          line-height:1.15;
          font-family:"Space Grotesk", system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
          font-size: clamp(1.75rem, 2.2vw + 1.1rem, 2.4rem);
        }

        /* === Subline === */
        .ccoffer-sub{
          color:var(--muted);
          margin:0 0 8px;
          font-size: 1.1rem;
        }
        .text-white{ color:#fff !important; }

        /* === Prices: inline (mobile/tablet), absolute bottom-right (desktop) === */
        .ccoffer-price-row{
          display:flex; align-items:baseline; gap:18px;
        }
        .ccoffer-price-row .old{
          color:var(--muted);
          font-size:1.25rem; /* slightly bigger as requested */
          text-decoration:line-through;
          text-decoration-thickness:1.5px;
          text-decoration-color:rgba(154,161,159,.7);
        }
        .ccoffer-price-row .new{
          color:var(--teal);
          font-weight:800;
          font-size: clamp(2rem, 3.2vw + .5rem, 3rem);
          line-height:1;
        }

        /* Desktop pin to bottom-right */
        @media (min-width:1200px){
          .ccoffer-price-row{
            position:absolute;
            right:40px;
            bottom:40px;
          }
        }

        /* === CTA === */
        .ccoffer-cta{
          border-radius:999px;
          padding:.6rem 1.25rem;
          border-color:var(--teal)!important;
          color:var(--teal)!important;
          background:transparent;
          transition:background-color .2s, color .2s;
        }
        .ccoffer-cta:hover, .ccoffer-cta:active{
          background:var(--teal)!important; color:#050505!important;
        }
      `}</style>
    </div>
  );
}
